import { compose, createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'
import { persistStore, autoRehydrate } from 'redux-persist'
import reducer from './reducers'
import Sagas from './sagas'

// default state
const default_state = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()

// middlewares
const sagaMiddleware = createSagaMiddleware()
const middlewares = [
  sagaMiddleware,
  routerMiddleware(browserHistory),
]

// store
const store = createStore(reducer, default_state,
  compose(
    applyMiddleware(...middlewares),
    autoRehydrate(),
  ),
)

// redux-persist
export const persistor = persistStore(store,{blacklist: ['routing','form']})

// middlewares
sagaMiddleware.run(Sagas)

export default store



// WEBPACK FOOTER //
// ./src/store.jsx